import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const LanguageToggle: React.FC = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const isEnglish = i18n.language === 'en';

  const toggleLanguage = () => {
    const currentPath = location.pathname;

    if (isEnglish) {
      // Switch to Spanish
      i18n.changeLanguage('es');
      // Remove /en prefix
      const newPath = currentPath.replace(/^\/en/, '') || '/';
      navigate(newPath);
    } else {
      // Switch to English
      i18n.changeLanguage('en');
      // Add /en prefix
      const newPath = currentPath === '/' ? '/en' : `/en${currentPath}`;
      navigate(newPath);
    }
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 px-3 py-1 rounded-full border border-gray-300 hover:border-purple-500 transition-colors bg-white"
      aria-label={isEnglish ? 'Cambiar a Espanol' : 'Switch to English'}
    >
      <span className={`text-sm font-medium ${!isEnglish ? 'text-purple-700' : 'text-gray-500'}`}>
        ES
      </span>
      <span className="text-gray-300">|</span>
      <span className={`text-sm font-medium ${isEnglish ? 'text-purple-700' : 'text-gray-500'}`}>
        EN
      </span>
    </button>
  );
};

export default LanguageToggle;
